import React, { useEffect, useRef, useState } from "react";
import styles from "./preset-changer.module.css";
import { v4 } from "uuid";

export default function PresetChanger({ showEditButtons = true, presets, selectedIndex, setSelectedIndex, changePresetName }) {
    const deckNamesRef = useRef(null);
    const deckNameInputRef = useRef(null);

    const [isWriting, setIsWriting] = useState(false);
    const [text, setText] = useState("");
    const [nameWidth, setNameWidth] = useState(178);

    const deckNameX = selectedIndex * nameWidth;

    useEffect(() => {
        if (isWriting) deckNameInputRef.current.focus();
    }, [isWriting]);

    useEffect(() => {
        const calcNameWrapperWidth = () => {
            let width = 0;
            if (deckNamesRef.current === null) {
                width = 178;
            } else {
                width = deckNamesRef.current.offsetWidth;
            }

            setNameWidth(width);
        };

        const observer = new ResizeObserver(calcNameWrapperWidth);

        if (deckNamesRef.current) {
            observer.observe(deckNamesRef.current);
        }

        window.addEventListener("resize", calcNameWrapperWidth);

        return () => {
            observer.disconnect();
            window.removeEventListener("resize", calcNameWrapperWidth);
        };

        // const raf = requestAnimationFrame(() => {
        //     requestAnimationFrame(calcNameWrapperWidth);
        // });

        // window.addEventListener("resize", calcNameWrapperWidth);
        // // calcNameWrapperWidth();

        // return () => {
        //     cancelAnimationFrame(raf);
        //     window.removeEventListener("resize", calcNameWrapperWidth);
        // };
    }, []);

    const onKeyPress = (e) => {
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            changePresetName(e.target.value);
            // dispatch(changeDeckName(e.target.value));
            setIsWriting(false);
        } else if (e.key === "Escape") {
            setIsWriting(false);
        }
    };

    return (
        <div className={styles["deck-changer"]}>
            <button
                type="button"
                className={styles["arrow"]}
                onClick={() => {
                    if (!isWriting && selectedIndex > 0) {
                        setSelectedIndex(selectedIndex - 1);
                    }
                }}
            >
                <i className="fi fi-rr-arrow-circle-left" />
            </button>
            <div className={styles["deck-names-wrapper"]} ref={deckNamesRef}>
                <div className={styles["deck-names"]} style={{ transform: `translateX(-${deckNameX}px)` }}>
                    {presets.map((preset, index) => {
                        return (
                            <div
                                className={`${styles["deck-name"]} ${index === selectedIndex && isWriting ? `${styles["disabled"]}` : ""}`}
                                style={{ minWidth: `${nameWidth}px`, maxWidth: `${nameWidth}px` }}
                                key={v4()}
                            >
                                {preset.name}
                            </div>
                        );
                    })}
                </div>
                <div className={`${styles["deck-name-change-input"]} ${isWriting ? `${styles["active"]}` : ""}`}>
                    <input
                        id="deck-name-input"
                        type="text"
                        ref={deckNameInputRef}
                        value={text}
                        onKeyDown={onKeyPress}
                        onChange={(e) => setText(e.target.value)}
                        enterKeyHint="done"
                    />
                </div>
            </div>
            {showEditButtons && presets[selectedIndex]?.slot !== 0 && (
                <div className={`${styles["deck-name-change-buttons"]} ${isWriting ? styles["active"] : ""}`}>
                    <button
                        type="button"
                        className={isWriting ? `${styles["disabled"]}` : ""}
                        onClick={() => {
                            setText(presets[selectedIndex].name);
                            setIsWriting(true);
                        }}
                    >
                        <i className="fi fi-rr-pen-circle" />
                    </button>
                    <button
                        type="button"
                        className={isWriting ? "" : `${styles["disabled"]}`}
                        onClick={() => {
                            changePresetName(text);
                            // dispatch(changeDeckName(text));
                            setIsWriting(false);
                        }}
                    >
                        <i className="fi fi-rr-check-circle" />
                    </button>
                    <button
                        type="button"
                        className={`${styles["cancel-button"]} ${isWriting ? "" : `${styles["disabled"]}`}`}
                        onClick={() => setIsWriting(false)}
                    >
                        <i className="fi fi-rr-circle-xmark" />
                    </button>
                </div>
            )}
            <button
                type="button"
                className={styles["arrow"]}
                onClick={() => {
                    if (!isWriting && selectedIndex < presets.length - 1) {
                        setSelectedIndex(selectedIndex + 1);
                    }
                }}
            >
                <i className="fi fi-rr-arrow-circle-right" />
            </button>
        </div>
    );
}
